// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { costCodesStyles } from "@insite/content-library/Widgets/Budget/CostCodes";
import { getProp } from "@insite/mobius/utilities";
import { TooltipPresentationProps } from "@keller/MobiusOverrides/Tooltip";
import Trash from "@keller/XDL/Icons/Trash";
import { color, xScreen } from "@keller/XDL/Utilities";
import { pageTitleStyle } from "@keller/XDL/Utilities/sharedStyles";
import { css } from "styled-components";

costCodesStyles.titleText = pageTitleStyle;

costCodesStyles.costCodeTitleText = {
    variant: "h6",
    css: css`
        display: inline-block;
        margin-right: 3px;
        margin-bottom: 10px;
    `,
};

costCodesStyles.buttonsGridItem = {
    width: [12, 12, 4, 4, 4],
    css: css`
        display: flex;
        justify-content: flex-end;
        ${xScreen("lte", "xs")} {
            flex-wrap: wrap;
        }
        & > div {
            display: flex;
            width: 100%;
            ${xScreen("lte", "xs")} {
                flex-wrap: wrap;
            }
            ${xScreen("gt", "sm")} {
                display: none;
            }
        }
    `,
};

costCodesStyles.cancelButton = {
    variant: "secondary",
    css: css`
        order: 1;
        margin-left: 10px;
        ${xScreen("lte", "sm")} {
            width: 50%;
        }
        ${xScreen("lte", "xs")} {
            width: 100%;
            margin-left: 0;
            margin-top: 10px;
        }
    `,
};

costCodesStyles.saveButton = {
    css: css`
        ${xScreen("lte", "sm")} {
            width: 50%;
        }
        ${xScreen("lte", "xs")} {
            width: 100%;
        }
    `,
};

costCodesStyles.costCodesTableGridItems = {
    width: 12,
};

costCodesStyles.removeIcon = {
    src: Trash,
    size: 16,
    css: css`
        display: block;
        cursor: pointer;
        margin: auto;
        transition: all ${getProp("theme.transition.duration.regular")}ms ease-in-out;

        &:hover {
            color: ${color("danger")};
        }
    `,
};

costCodesStyles.dataTableCells = {
    css: css`
        cursor: auto;
    `,
};

costCodesStyles.addCostCodeButton = {
    css: css`
        display: block;
        ${xScreen("lte", "xs")} {
            width: 100%;
        }
    `,
    variant: "secondary",
};

costCodesStyles.costCodeTitleTooltip = {
    cssOverrides: {
        tooltipContainer: css`
            margin-top: -2px;
        `,
    },
};
